export default __webpack_public_path__ + "static/media/guide_dev_06.7d7521bf.md";